import { BRAND } from '../../config/brand';
import './Legal.css';

function LegalTerms() {
  return (
    <main className="legal-page">
      <div className="container">
        <div className="legal-card">
          <h1 className="legal-title">Terms of Service</h1>
          <div className="legal-meta">
            Last updated: {BRAND.legal.lastUpdated} • {BRAND.legal.companyName}
          </div>

          <div className="legal-content">
            <p>
              These Terms of Service govern your purchase of domain registration services and related fulfillment from{' '}
              <strong>{BRAND.legal.companyName}</strong> ("we", "us").
            </p>

            <h2>1) What We Provide</h2>
            <p>
              We sell and fulfill domain-related services. A typical purchase includes domain registration for the term shown
              at checkout (often 1 year) and basic setup support.
            </p>

            <h2>2) Domain Availability</h2>
            <p>
              Domain availability can change quickly. We do our best to confirm availability, but we cannot guarantee a domain
              remains available until registration is completed.
            </p>

            <h2>3) Payment & Confirmation</h2>
            <p>
              Payment is processed via PayPal. Your order is considered paid once our system records a successful payment
              confirmation.
            </p>

            <h2>4) Fulfillment</h2>
            <p>
              After payment, we attempt to register the domain. If registration is successful, we may contact you for any
              required information and help with basic DNS configuration.
            </p>

            <h2>5) If the Domain Becomes Unavailable</h2>
            <p>
              If the domain becomes unavailable after payment (or cannot be registered for any reason outside our control), we
              will either (a) offer reasonable alternatives, or (b) process a refund according to our Refund Policy.
            </p>

            <h2>6) Refunds</h2>
            <p>
              See our <a className="legal-link" href="/legal/refunds">Refund Policy</a> for details.
            </p>

            <h2>7) Acceptable Use</h2>
            <p>
              You agree not to use the service for unlawful activity. You are responsible for compliance with applicable laws
              and third‑party policies.
            </p>

            <h2>8) Disclaimers</h2>
            <p>
              Except as required by law, the service is provided “as is” without warranties of any kind. We do not guarantee
              search rankings, traffic, revenue, or business outcomes.
            </p>

            <h2>9) Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, our liability is limited to the amount you paid for the specific order in
              question.
            </p>

            <h2>10) Contact</h2>
            <p>
              For support or legal requests, contact{' '}
              <a className="legal-link" href={`mailto:${BRAND.legal.contactEmail}`}>{BRAND.legal.contactEmail}</a>.
            </p>

            <h2>11) Legal Review Note</h2>
            <p>
              This document is a practical starting point and should be reviewed by legal counsel for your jurisdiction, entity
              details, and any required disclosures.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default LegalTerms;
